import { Coord } from "../types/Interface";
import addInteractivity from "../utils/addInteractivity";
import Point from "./Point";
import { CustomCursorType } from "./UI/CustomCursor/CustomCursor";


export default class RedPoint extends Point {
  tag: string;
  constructor(tag: string, coord: Coord, _handleDown: (p: string) => void, handleUpFunc: () => void) {
    super(coord);
    this.tag = tag;
    this.fillColor = 0xFF0000;
    this.eventMode = "static";
    const handleDownFunc = () => _handleDown(this.tag);
    addInteractivity(
      this,
      { handleDownFunc, handleUpFunc },
      CustomCursorType.grab
    )
  }
}